import React, { useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import TopTokensComponent from "./TopTokens.component";

const timeOffsets = {
  "1min": 60 * 1000,
  "5min": 5 * 60 * 1000,
  "15min": 15 * 60 * 1000,
  "1h": 60 * 60 * 1000,
  "4h": 4 * 60 * 60 * 1000,
  "12h": 12 * 60 * 60 * 1000,
  "1d": 24 * 60 * 60 * 1000,
  "1w": 7 * 24 * 60 * 60 * 1000,
  "1m": 30.44 * 24 * 60 * 60 * 1000,
};

const TokensToWatch = () => {
  const { t } = useTranslation();

  const [selectedTimeOffset, setSelectedTimeOffset] = useState("4h");
  const [selectedCategory, setSelectedCategory] = useState("winners");

  const handleTimeOffsetsChange = (event) => {
    setSelectedTimeOffset(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  return (
    <Box
      sx={{
        width: "100%",
        // maxWidth: 600,
        minHeight: "100%", // Ensures it doesn’t collapse
        display: "flex",
        flexDirection: "column", // Prevents shrinking
        // mx: "auto",
        p: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // backgroundColor: "#f5f5f5",
          //   p: 1,
          //   borderRadius: 1,
          //   boxShadow: 1,
          //   gap: 1,
          minHeight: 40, // Compact height
          width: "100%",
          // height: "100%"
        }}
      >
        <Typography
          variant="subtitle2"
        //   sx={{ flexGrow: 1, textAlign: "center" }}
        >
          {t('table.topTokens')}
        </Typography>



        {/* Time Interval Selector */}
        <FormControl sx={{ minWidth: 100 }} size="small">
          {/* <InputLabel id="time-interval-label">Time</InputLabel> */}
          <Select
            labelId="time-interval-label"
            value={selectedTimeOffset}
            onChange={handleTimeOffsetsChange}
            sx={{
              border: "1px solid rgba(255,255,255,0.4)",
            }}
          // sx={{backgroundColor:"white", color:"white"}}
          >
            {Object.keys(timeOffsets).map((key) => (
              <MenuItem key={key} value={key}>
                {t(`timeIntervals.${ key }`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <TopTokensComponent selectedTimeOffset={selectedTimeOffset} selectedCategory={selectedCategory} />

    </Box>
  );
};

export default TokensToWatch;
